import { Log } from '../AuxillaryService/Log';
import { pauseCurrentDisplay, playCurrentDisplay, stopCurrentDisplay } from '../Display';

/**
 * Run during initialize, this is used to create hotkey commands that can be
 * used by any platform.
 *
 * _Note:_ `ctrl + alt` commands are reserved for use by the player software.
 *
 * Here are the current hotkeys and their functionality:
 *
 * - `alt + p`: pauses the signage.
 * - `alt + r`: resumes the signage from a pause or stopped state.
 * - `alt + s`: stops the signage. This causes all DOM elements to be destroyed.
 */
export function addGlobalHotkeys(): void {
    document.addEventListener('keyup', function (e) {
        if (e.altKey) {
            if (e.ctrlKey) {
                // ctrl + alt commands are reserved for use by the player
                // software
                return;
            }

            // alt down
            switch (e.keyCode) {
                case 82: //r
                    Log.Info(
                        'Resume shortcut pressed. Will resume the current display.',
                        null,
                        __fileline
                    );
                    playCurrentDisplay();
                    break;
                case 80: //p
                    Log.Info(
                        'Pause shortcut pressed. Will pause the current display.',
                        null,
                        __fileline
                    );
                    pauseCurrentDisplay();
                    break;
                case 83: //s
                    Log.Info(
                        'Stop shortcut pressed. Will stop the current display.',
                        null,
                        __fileline
                    );
                    stopCurrentDisplay();
                    break;
            }
        }
    });
}
